<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div>
    <v-file-input
      :value="dxffile"
      ref="fileupload"
      :placeholder="language.t('FormFields.DxfInput.chooseFile')"
      @change="onSelectFile"
      accept=".dxf"
      prepend-icon="$vuetify.icons.DXF"
      truncate-length="15"
      dense
      :rules="acadVerWarning"
    ></v-file-input>
    <v-select
      v-model="selectedLayer"
      :items="layers"
      :rules="largeFileWarning"
      :placeholder="language.t('FormFields.DxfInput.chooseLayer')"
      @input="$emit('update:layername', $event.layername); $emit('update:numfeatures', $event.numfeatures);"
      dense
    >
      <template
        slot="selection"
        slot-scope="data"
      >
        {{ data.item.layername }} ({{ data.item.numfeatures }} {{ language.t('FormFields.DxfInput.features') }})
      </template>
      <template
        slot="item"
        slot-scope="data"
      >
        {{ data.item.layername }} ({{ data.item.numfeatures }} {{ language.t('FormFields.DxfInput.features') }})
      </template>
    </v-select>
  </div>
</template>

<script>
//TODO: request update to dxf package.
import DXFFile from "../../webcomponents/models/DXFFile";
import * as CONST from "../../Constants";

export default {
  props: {
    dxffile: File,
    layername: String,
    numfeatures: Number,
  },
  emits: ["update:dxffile", "update:layername", "update:numfeatures"],
  data() {
    return {
      selectedLayer: null,
      layers: [],

      largeFileWarning: [(layer) => layer?.numfeatures <= 100000 || layer == undefined || this.language.t("FormFields.DxfInput.largeFileWarning")],
      acadVerWarning: [true]
    };
  },
  methods: {
    onSelectFile(file) {
      // console.log(file);
      // if (file.type != "application/dxf") return;
      if (!file) {
        this.reset();
        return;
      }

      this.layers = [];
      const reader = new FileReader();
      reader.onload = (res) => {
        var dxf = new DXFFile(res.target.result);
        if (CONST.__SUPPORTED_ACADVERS.indexOf(dxf.acadVer) !== -1) {
          this.acadVerWarning = [true];
          Object.keys(dxf.groups).forEach((layer) => {
            let numfeatures = dxf.groups[layer].length;
            let item = { layername: dxf.getLayerInfo(layer).name, numfeatures: numfeatures };
            if (numfeatures > 0) {
              this.selectedLayer = item;
              this.$emit("update:layername", item.layername);
              this.$emit("update:numfeatures", item.numfeatures);
            }
            this.layers.push(item);
          });
        } else {
          this.acadVerWarning = [this.language.t("RobotPlotter.CreateTask.unsupportedVersion")];
        }
      };
      reader.onerror = (err) => console.log(err);
      reader.readAsText(file);
      this.$emit("update:dxffile", file);
    },
    reset() {
      this.layers = [];
      this.selectedLayer = null;
    },
  },
};
</script>
